module.exports = __webpack_public_path__ + "static/img/4.ca8dd38.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/2/sp/4.png
// module id = mvtm
// module chunks = 0